import { AvailabilityParsedItem } from 'shared/components/availability/availability-calendar.types';
import { getFullNameWithInfix } from 'hq/components/views/flexWorkers/utils';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { AvailabilityForEdit } from '../wizard/availability-sidebar';

export type AvailabilityMode = 'create' | 'edit';

export const useAvailabilityActionHandler = () => {
  const [isSideBarOpen, setIsSideBarOpen] = useState<boolean>(false);
  const [availabilityForEdit, setAvailabilityForEdit] = useState<AvailabilityForEdit | null>(null);
  const [mode, setMode] = useState<AvailabilityMode>('edit');

  const handleEditAvailability = (availabilities: AvailabilityParsedItem[]) => {
    if (availabilities.length === 0) {
      return;
    }

    const [firstAvailability] = availabilities;
    if (firstAvailability.workerForPopover?.partnerName) {
      return;
    }

    const mappedAvailabilityForEdit: AvailabilityForEdit = mapAvailabilityForEdit(availabilities);
    setMode('edit');
    setIsSideBarOpen(true);
    setAvailabilityForEdit(mappedAvailabilityForEdit);
  };

  const handleCreateAvailability = () => {
    setMode('create');
    setIsSideBarOpen(true);
    setAvailabilityForEdit(null);
  };

  return {
    isSideBarOpen,
    availabilityForEdit,
    handleEditAvailability,
    handleCreateAvailability,
    setIsSideBarOpen,
    mode,
  };
};

const mapAvailabilityForEdit = (availabilities: AvailabilityParsedItem[]): AvailabilityForEdit => {
  const [firstAvailability] = availabilities;
  return {
    selectedWorker: {
      id: firstAvailability.workerForPopover.workerId,
      name: getFullNameWithInfix(firstAvailability.workerForPopover),
      description: firstAvailability.workerForPopover.email,
    },
    availabilitySegments: availabilities
      .sort((a, b) => {
        const aDateTime = DateTime.fromISO(a.utcStartDateTime);
        const bDateTime = DateTime.fromISO(b.utcStartDateTime);
        return aDateTime < bDateTime ? -1 : aDateTime > bDateTime ? 1 : 0;
      })
      .map((segment) => ({
        segmentId: segment.segmentId,
        utcStartDateTime: DateTime.fromISO(segment.utcStartDateTime).toFormat('T'),
        utcEndDateTime: DateTime.fromISO(segment.utcEndDateTime).toFormat('T'),
      })),
    availabilityDate: DateTime.fromISO(firstAvailability.utcStartDateTime),
  };
};
